export function removerAcentos(texto) {
  if (!texto) return undefined

  const textoSemAcentos = texto.normalize('NFD').replace(/[\u0300-\u036f]/g, '')

  // Remover aspas simples, aspas duplas e barra invertida
  const textoSemPontuacao = textoSemAcentos.replace(/['"\\/]/g, '')

  return textoSemPontuacao
}
